import { render, staticRenderFns } from "./CarouselProducts.vue?vue&type=template&id=70d0297e&scoped=true&"
import script from "./CarouselProducts.vue?vue&type=script&lang=ts&"
export * from "./CarouselProducts.vue?vue&type=script&lang=ts&"
import style0 from "./CarouselProducts.vue?vue&type=style&index=0&id=70d0297e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d0297e",
  null
  
)

export default component.exports